import { runInAction } from 'mobx';
import { beforeUploadFile, uploadFile } from './utils';
import { getConfig } from '../configure';
import UploadError from './UploadError';
export default class Uploader {
    constructor(props, context = { getConfig }) {
        this.props = props;
        this.context = context;
    }
    setProps(props) {
        Object.assign(this.props, props);
    }
    async upload(attachment, attachments, tempAttachmentUUID) {
        const { attachmentUUID = tempAttachmentUUID } = attachment;
        if (attachment.status === 'success' || attachment.invalid || !attachmentUUID) {
            return;
        }
        const { context, props } = this;
        const globalConfig = context.getConfig('attachment');
        const { chunkSize = globalConfig.defaultChunkSize } = props;
        const useChunk = props.useChunk && chunkSize > 0 && attachment.size > chunkSize;
        const result = await beforeUploadFile(props, context, attachment, attachments, useChunk);
        if (result === true) {
            try {
                const resp = await uploadFile(props, attachment, attachmentUUID, context, chunkSize, useChunk);
                runInAction(() => {
                    attachment.status = 'success';
                    const { onUploadSuccess: handleUploadSuccess } = globalConfig;
                    if (handleUploadSuccess) {
                        handleUploadSuccess(resp, attachment, {
                            useChunk,
                            bucketName: props.bucketName,
                            bucketDirectory: props.bucketDirectory,
                            storageCode: props.storageCode,
                            isPublic: props.isPublic,
                        });
                    }
                    const { onUploadSuccess } = props;
                    if (onUploadSuccess) {
                        onUploadSuccess(resp, attachment, useChunk);
                    }
                });
                return resp;
            }
            catch (error) {
                if (error instanceof UploadError) {
                    const { response } = error;
                    runInAction(() => {
                        const { onUploadError } = props;
                        const { onUploadError: handleUploadError } = globalConfig;
                        attachment.status = 'error';
                        attachment.error = error;
                        const { message } = error;
                        if (handleUploadError) {
                            handleUploadError(error, attachment);
                        }
                        attachment.errorMessage = message || attachment.errorMessage;
                        if (onUploadError) {
                            onUploadError(error, response, attachment);
                        }
                    });
                    return response;
                }
                throw error;
            }
        }
        return result;
    }
}
